import { createRouter, createWebHistory } from 'vue-router'
import BookingStep1 from '../Views/Booking/BookingStep1.vue'
import BookingStep2 from '../Views/Booking/BookingStep2.vue'
import BookingStep3 from '../Views/Booking/BookingStep3.vue'
import BookingStep4 from '../Views/Booking/BookingStep4.vue'
import BookingStep5 from '../Views/Booking/BookingStep5.vue'
import { getData } from '../../lib/lib'

const bookingComponents = [
  BookingStep1,
  BookingStep2,
  BookingStep3,
  BookingStep4,
  BookingStep5,
]

const testRoute = [
  {
    path: '/html/03.Booking.html',
    redirect: (path) => {
      return {
        name: 'first-step',
        query: {
          // movieId: 'HO00002014',
          // cinemaId: '26',
          // date: 'day-2',
          // screen: '26-65546'
          ...path.query,
        },
      }
    },
  },
]
const bookingRouteData = getData('bookingRouteData')
const bookingRoutes = bookingRouteData.routes.map((r, index) => {
  return {
    path: bookingRouteData.basePath + '/' + r.path,
    name: r.name,
    component: bookingComponents[index],
  }
})
const routes = [...testRoute, ...bookingRoutes]

// const routes = [
//   {
//     path: '/html/03.Booking.html',
//     redirect: (path) => {
//       return {
//         name: 'first-step',
//         params: {
//           language: 'el',
//         },
//         query: {
//           // movieId: 'video-2',
//           // cinemaId: '26',
//           // date: 'day-2',
//           // screen: '26-65546'
//           ...path.query,
//         },
//       }
//     },
//   },

//   {
//     path: '/:language/booking/first-step',
//     name: 'first-step',
//     component: BookingStep1,
//   },
//   {
//     path: '/:language/booking/second-step',
//     name: 'second-step',
//     component: BookingStep2,
//   },
//   {
//     path: '/:language/booking/third-step',
//     name: 'third-step',
//     component: BookingStep3,
//   },
//   {
//     path: '/:language/booking/fourth-step',
//     name: 'fourth-step',
//     component: BookingStep4,
//   },
//   {
//     path: '/:language/booking/fifth-step',
//     name: 'fifth-step',
//     component: BookingStep5,
//   },
// ]

const BookingRoutes = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return
    }
    return {
      top: 0,
      behavior: 'smooth',
    }
  },
})

export default BookingRoutes
